import { Injectable } from '@angular/core';

interface OrderTypes {
  Event: string;
  Inventory: string;
  Combo: string;
  ComboInventory: string;
  RebookingFee: string;
  MembershipPurchase: string;
  MembershipRenewal: string;
  MembershipUpgrade: string;
  MembershipDowngrade: string;
  MembershipCancel: string;
  MembershipPostTermRenewal: string;
  MembershipRejoin: string;
  MembershipRenewalUpgrade: string;
  MembershipPostTermRenewalUpgrade: string;
  MembershipRejoinUpgrade: string;
  MembershipPostTermRenewalDowngrade: string;
  MembershipRejoinDowngrade: string;
  MembershipRenewalDowngrade: string;
  MembershipPurchaseConversion: string;
  MembershipReplacement: string;
  Donation: string;
}

/**
 * OrderService (Angular 18)
 *
 * Replaces: apps/b2b-ui/common/services/order/order.service.js
 * Manages order storage and item type classification.
 */
@Injectable({ providedIn: 'root' })
export class OrderService {
  model: Record<string, unknown> = {};
  stored = false;

  readonly types: OrderTypes = {
    Event: 'Event',
    Inventory: 'Add-on',
    Combo: 'Event',
    ComboInventory: 'Add-on',
    RebookingFee: 'Fee',
    MembershipPurchase: 'New Purchase',
    MembershipRenewal: 'Renewal',
    MembershipUpgrade: 'Upgrade',
    MembershipDowngrade: 'Downgrade',
    MembershipCancel: 'Cancellation',
    MembershipPostTermRenewal: 'Post Term Renewal',
    MembershipRejoin: 'Rejoin',
    MembershipRenewalUpgrade: 'Renewal Upgrade',
    MembershipPostTermRenewalUpgrade: 'Post Term Renewal Upgrade',
    MembershipRejoinUpgrade: 'Rejoin Upgrade',
    MembershipPostTermRenewalDowngrade: 'Post Term Renewal Downgrade',
    MembershipRejoinDowngrade: 'Rejoin Downgrade',
    MembershipRenewalDowngrade: 'Renewal Downgrade',
    MembershipPurchaseConversion: 'Purchase Conversion',
    MembershipReplacement: 'Replacement',
    Donation: 'Donation',
  };

  // ─── Initialization ───────────────────────────────────────────────────────

  init(): boolean {
    return true;
  }

  // ─── Storage management ───────────────────────────────────────────────────

  store(order: Record<string, unknown>): void {
    this.stored = true;
    this.model = order;
  }

  fetch(): Record<string, unknown> | false {
    return this.stored ? this.model : false;
  }

  clear(): boolean {
    this.model = {};
    this.stored = false;
    return true;
  }

  // ─── Item type classification ─────────────────────────────────────────────

  /**
   * Classify order item type based on type and optional subType.
   * Maps internal type names to display-friendly labels.
   */
  getItemType(type: string, subType?: string): string | undefined {
    if (type === 'Inventory' || type === 'ComboInventory') {
      return 'Add-on';
    }

    if (type === 'Event' || type === 'Combo') {
      return 'Ticket';
    }

    if (type === 'RebookingFee' || type === 'Fee') {
      return 'Fee';
    }

    if (type && type.toLowerCase().indexOf('membership') > -1) {
      if (subType) {
        return (this.types as any)[type] || 'Membership';
      }
      return 'Membership';
    }

    return undefined;
  }
}
